import { Grid } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import Table, { ILineItemRow } from 'app/components/Core/LineItem/Table'
import Filters from 'app/components/Core/LineItem/Table/Filters'
import useStatusFilter from 'app/components/Core/LineItem/Table/hooks/useStatusFilter'
import KTable from 'app/components/Modules/Table/_KTable'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import { ComponentProps, FC } from 'react'
import { Link } from 'react-router-dom'

type Props = Partial<ComponentProps<typeof KTable<ILineItem>>>

const MachineList: FC<CollectionProps<ILineItem, Props>> = ({ props }) => {
  const { tRecordType } = useTranslation({
    recordType: RecordType.line_item,
    scope: 'title'
  })
  const { tRoute } = useTranslation({ scope: 'project.show' })
  const { statusFilter } = useStatusFilter()

  // Fetch subItems as nested attribute for mobile view, and as top level attribute otherwise
  const { xs: isMobile } = Grid.useBreakpoint()

  const params = {
    excludeSubItems: isMobile,
    lineItemType: ['product'],
    period: [statusFilter].filter(Boolean),
    sort: [
      { sortField: 'rental_id', sortDirection: 'desc' },
      { sortField: 'created_at', sortDirection: 'asc' }
    ],
    ...props?.params
  }

  const extraColumns = [
    {
      title: tRoute({ id: 'rental_code' }),
      dataIndex: 'rentalCode',
      render: (text: string, record: ILineItem) => (
        <Link to={Routes.Rental.member(record.rentalId.toString()).show}>
          <Button size="small" title={text} type="default" />
        </Link>
      )
    }
  ]

  return (
    <KCol card span={24} title={tRecordType({ id: 'list_title' })}>
      <Table
        filters={<Filters />}
        transformData={transformData}
        extraColumns={extraColumns}
        expandable={{ defaultExpandAllRows: true }}
        {...props}
        params={params}
      />
    </KCol>
  )
}

export default MachineList

export function transformData(data: Array<ISubItem>) {
  return data.filter(parentOrOrphan).map(appendChildren)

  function parentOrOrphan({ lineItemId }: ISubItem) {
    // Parent line item
    if (!lineItemId) return true

    // Orphan sub items, whose parent are not part of current response/page
    return !data.find(({ id }) => id.toString() === lineItemId.toString())
  }

  function appendChildren(lineItem: ISubItem): ILineItemRow {
    const children = data
      .filter(({ lineItemId }) => lineItemId && lineItemId.toString() === lineItem.id.toString())
      .map(appendChildren)

    return {
      ...lineItem,
      children: children.length ? children : undefined
    }
  }
}
